export const state = () => ({
  showNavbar: "",
  currentUrl: "",
  jobs: [],
  acceptedYoutubePolicy: false,
  startAnimationDone: false,
  acceptedHubspotPolicy: false,
});

export const mutations = {
  showNavbar(state, isDesktop) {
    state.showNavbar = isDesktop;
  },
  setAcceptedYoutubePolicy(state, bool) {
    state.acceptedYoutubePolicy = bool;
  },
  setAcceptedHubspotPolicy(state, bool) {
    state.acceptedHubspotPolicy = bool;
  },
  startAnimationDone(state, bool) {
    state.startAnimationDone = bool;
    localStorage.setItem("startAnimationDone", bool);
  },
  setData(state, { storage, key, data }) {
    Vue.set(storage, key, data);
  },
};
